import React from 'react'
import { Link ,useNavigate} from 'react-router-dom'
import { Button } from '../../layout';
import {CiLogin ,MdOutlineCancel ,BsCurrencyDollar} from "../../utils/icons"
import {  useSelector ,useDispatch } from "react-redux";
import DButton from './DButton';
import { media } from '../../../server';
import { LogoutUser } from '../../../redux/actions/user';
import { useTranslation } from 'react-i18next';
import { SpinButton } from '../../utils/Form';
import { useStateContext } from '../../../context/ContextProvider';
import { truncateTitle } from '../../../middleware/truncateTitle';
const AdminProfil = () => {
    const { user } = useSelector((state) => state.Users);
    const {currentColor}=useStateContext()
    const dispatch = useDispatch();
    const navigate = useNavigate();
  const { t } = useTranslation();
    const LogoutHandeler =()=>{
        dispatch(LogoutUser())
        navigate("/login")
      
      }
    return (
        <div className="nav-item  absolute ltr:right-1  rtl:left-1 top-16 bg-white dark:bg-back-darksecondary p-8 rounded-lg w-96">
          <div className="flex justify-between items-center">
            <p className="font-semibold  font-kufi text-lg dark:text-gray-200">{t("Admin Profile")}</p>
            <DButton
              icon={<MdOutlineCancel />}
              color="rgb(153, 171, 180)"
              bgHoverColor="gray-200"
              size="2xl"
              borderRadius="50%"
            />
          </div>
          <div className="flex gap-5 items-center mt-6 border border-r-0 border-l-0 border-t-0  border-b-1 border-gray-300 pb-6">
            <img
              className="rounded-full h-24 w-24"
              src={`${media}${user.avatar}`}
              alt="user-profile"
            />
            <div>
              <p className="font-semibold text-xl font-kufi dark:text-gray-200">{`${truncateTitle(user.name,2)}`}</p>
              <p className="text-gray-500 font-kufi text-sm dark:text-gray-400"> {`${user.phoneNumber}`} </p>
              <p className="text-gray-500 text-sm font-kufi font-semibold dark:text-gray-400"> {`${user.email}`} </p>
            </div>
          </div>
          <div 
      onClick={LogoutHandeler}
      className="mt-5 h1ar">
        <DButton
          color="white"
          bgColor={currentColor}
          text={t("Logout")}
          borderRadius="10px"
          width="full"
        />
      </div>
        </div>
    
      );

}

export default AdminProfil